// extracted by mini-css-extract-plugin
export default {"toopTipImage":"infoBox_toopTipImage__2ywOj"};